export enum SelfPayFollowupStatus {
  SENT = "sent",
  NEEDS_REVIEW = "needs_review",
}

export enum PatientSchedulingInsuranceStatus {
  CLEARED = "cleared",
  REVIEW = "review",
  MISSING = "missing",
  SELF_PAY = "self_pay",
}
